import { Box } from '@mui/material';

export const CenterDivider = () => (
  <Box
    width="80%"
    height="3px"
    bgcolor="#B3B3B3"
    position="relative"
    left="50%"
    top="50%"
    sx={{
      transform: 'translate(-50%, -50%)',
    }}
  />
);
